import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postForgot } from '../../store/actions/user';
// reactstrap components
import {
	Button,
	Card,
	CardTitle,
	Form,
	Input,
	Container,
	Row,
	Col,
} from 'reactstrap';

// core components
import Navbar from '../Components/Navbar';

function LoginPage(rest) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [email, setEmail] = useState();
	const handleSubmit = (e) => {
		e.preventDefault();
		dispatch(postForgot(email));
		setEmail('');
		navigate(`/forgot`);
	};
	document.documentElement.classList.remove('nav-open');
	useEffect(() => {
		document.body.classList.add('login-page');
		document.body.classList.add('full-screen');
		return function cleanup() {
			document.body.classList.remove('login-page');
			document.body.classList.remove('full-screen');
		};
	}, []);
	useEffect(() => {
		try {
			dispatch(rest.removeError());
			dispatch(rest.removeSuccess());
		} catch (err) {
			console.log(err);
		}
	}, []);
	return (
		<>
			<Navbar />
			<div className='wrapper'>
				<div
					className='page-header'
					style={{
						backgroundImage:
							'url(' + require('assets/img/sections/david-marcu.jpg') + ')',
					}}>
					<div className='filter' />
					<Container>
						<Row>
							<Col className='ml-auto mr-auto' lg='6' md='7' sm='7'>
								<Card className='card-register'>
									{rest.errors.message && (
										<div className='alert alert-danger'>
											{rest.errors.message}
										</div>
									)}
									{rest.success.message && (
										<div className='alert alert-success'>
											{rest.success.message}
										</div>
									)}
									<CardTitle tag='h3'>Your Email Address</CardTitle>
									<Form className='register-form' onSubmit={handleSubmit}>
										<label>Email</label>

										<Input
											className='no-border'
											autoComplete='off'
											id='email'
											name='email'
											onChange={(e) => setEmail(e.target.value)}
											type='email'
											value={email}
											placeholder='Email'
											required
										/>

										<Button color='info' size='sm'>
											Submit
										</Button>
									</Form>
								</Card>
							</Col>
						</Row>
						<div className='demo-footer text-center'>
							<h6>
								© {new Date().getFullYear()}, made with{' '}
								<i className='fa fa-heart heart' /> by Weciny
							</h6>
						</div>
					</Container>
				</div>
			</div>
		</>
	);
}

export default LoginPage;
